import {ActiveGame, ActiveTrend} from "../types/nbaTypes";
import {NbaGame} from "../types/cbbTypes";
import {get8DigitDate} from "./timeUtils";
import {BetboardRow} from "../types/types";
import {mlbImageUrls, nbaTeamAbbreviations, ncaaImageUrls, nflImageUrls} from "./constants";

export const parseJwt = (token: string) => {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
};

export const getActiveTrends = (activeTrends: ActiveTrend[], currentMatchup: NbaGame) => {

    return activeTrends?.reduce(
        (acc:
             {
                 teamActiveTrends: ActiveTrend[],
                 oTeamActiveTrends: ActiveTrend[],
                 overActiveTrends: ActiveTrend[],
                 underActiveTrends: ActiveTrend[],
             }
            , trend: ActiveTrend) => {
            const isTeamActive = trend.isAtsTrend && trend.activeGames?.some((game: ActiveGame) => game.activeTeam === currentMatchup.team);
            const isOTeamActive = trend.isAtsTrend && trend.activeGames?.some((game: ActiveGame) => game.activeTeam === currentMatchup.oTeam);
            const overRatio = +(trend?.overs || 0) / +(trend?.unders || 0);
            const isOverTrend = trend.isOuTrend && overRatio > 1;
            const isUnderTrend = trend.isOuTrend && overRatio < 1;

            if (isTeamActive) acc.teamActiveTrends.push(trend);
            if (isOTeamActive) acc.oTeamActiveTrends.push(trend);
            if (isOverTrend) acc.overActiveTrends.push(trend);
            if (isUnderTrend) acc.underActiveTrends.push(trend);

            return acc;
        }, {
            teamActiveTrends: [],
            oTeamActiveTrends: [],
            overActiveTrends: [],
            underActiveTrends: [],
        })
}

export const getCurrentMatchup = (
    matchups: NbaGame[],
    team: string,
    oTeam: string,
    date: string
) => {
    console.log("getCurrentMatchup matchups: ", matchups)
    return matchups?.flatMap(
        (data: any) => data)?.find((matchup: any) => {
        return matchup?.team === team && matchup?.date.toString() === date.toString() && matchup?.oTeam === oTeam
    });
}

export const getOppWinPercentage = (oWins: number, oLosses:number) => {
    if (oWins + oLosses === 0) return 0.0;
    if (oLosses === 0 && oWins >= 1) return 1.0

    return oWins / (oWins + oLosses);
};

export const getActiveGames = (sdqlData: { sdqlQuery: BetboardRow[] }) => {
    const nextTenDays = new Array(11)
        .fill(1)
        .map((_, ind) => +get8DigitDate(-ind + 1));
    const activeGames = (
        sdqlData?.sdqlQuery as BetboardRow[])?.reduce((acc: ActiveGame[],game: BetboardRow) => {
        if (nextTenDays.includes(game?.date)) {
            acc.push({
                activeTeam: game.team,
                activeOTeam: game.oTeam,
                activeDate: game.date,
            });
        }
        return acc;
    }, []);

    return activeGames?.length > 0 ? activeGames : [];
};

export const calculatePercentage = (numerator?: number, denominator?: number) => {
    if(!numerator && !denominator) return '0%'
    if (numerator && !denominator) return '100%'
    if (!numerator && denominator) return '0%'
    const sum = numerator! + denominator!;
    return ((numerator! / sum) * 100).toFixed(1) + '%';
}

export const getImageUrl = (teamName: string, sport: string, height?: number, width?: number) => {
    let teamAbbreviation = ''
    if(sport === 'nba') {
        teamAbbreviation = nbaTeamAbbreviations[teamName]
        return (
            <img
                src={`https://a.espncdn.com/i/teamlogos/nba/500/${teamAbbreviation}.png`}
                height={height || 22}
                width={width || 22}
                style={{padding: 0, margin: 0}}
            />
        )
    }
    if(sport === 'nfl') {
        const teamImageUrl = nflImageUrls[teamName]
        return (
            <img
                src={teamImageUrl}
                height={height || 22}
                width={width || 34}
                style={{padding: 0, margin: 0}}
            />
        );
    }
    if(sport === 'mlb') {
        const teamImageUrl = mlbImageUrls[teamName]
        return (
            <img
                src={teamImageUrl}
                height={height || 22}
                width={width || 34}
                style={{padding: 0, margin: 0}}
            />
        );
    }
    if(sport === 'ncaabb' || sport === 'ncaafb') {
        const teamImageUrl = ncaaImageUrls[teamName]
        return (
            <img
                src={teamImageUrl}
                height={height || 22}
                width={width || 34}
                style={{padding: 0, margin: 0}}
            />
        );
    }
    return ''
};



